import { Disclosure } from '@starberry/components';
import { $ } from '@starberry/components';

const MobileSideMenu = {
  $: 'Flex',
  props: {
    display: { base: 'flex', lg: 'none' },
  },

  logoContainerProps: {
    mb: [4, 8, 16],
    width: 120,
    h: 'auto',
  },

  leftIcon: () => $('constants.icons.leftIcon'),

  logoContainer: (props) => {
    return {
      $: 'Box',
      props: props.logoContainerProps,
      children: {
        component: props.companyLogo,
        props: {
          id: 'mobileLogo',
        },
      },
    };
  },

  children: ({ placement = 'left', logoContainer, sideNav, leftIcon, leftIconProps }) => [
    {
      component: Disclosure,
      props: ['render'],
      render:
        () =>
        ({ isOpen, onOpen, onClose }) => {
          return {
            $: 'Flex',
            children: [
              {
                $: 'IconButton',
                props: {
                  icon: leftIcon,
                  fontSize: '24px',
                  color: 'black',
                  bgColor: 'transparent',
                  _hover: {
                    bgColor: 'transparent',
                  },
                  _active: {
                    bgColor: 'transparent',
                  },
                  _focus: {
                    boxShadow: 'none',
                  },
                  onClick: () => (isOpen ? onClose : onOpen),
                  ...leftIconProps
                },
              },
              {
                $: 'Drawer',
                props: {
                  isOpen: isOpen,
                  placement,
                  onClose: () => onClose,
                  zIndex: 99999,
                },
                children: [
                  {
                    $: 'DrawerOverlay',
                    children: [
                      {
                        $: 'DrawerContent',
                        props: {
                          bgColor: $('constants.sidebarBgColor'),
                          py: [8, 8, 10],
                          color: 'white',
                        },
                        children: [
                          { $: 'DrawerHeader' },
                          { $: 'DrawerCloseButton', props: { opacity: 0.5, _hover: { opacity: 1 }, _focus: { boxShadow: 'none' } } },
                          {
                            $: 'DrawerBody',
                            props: {
                              align: 'center',
                            },
                            children: [
                              { $: logoContainer },
                              {
                                $: 'SideMenu',
                                children: sideNav.map(({ visibility, ...item }) => {
                                  return {
                                    ...item,
                                    props: {
                                      ...item.props,
                                      display: visibility?.mobile ? 'flex' : 'none',
                                    },
                                  };
                                }),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          };
        },
    },
  ],
};

export default MobileSideMenu;
